var tsbu1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu1.jpg'
var tsbu2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu2.jpeg'
var tsbu3 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu3.jpeg'
var attached = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/attached.jpg'
var attachedDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/attachedDetail1.jpg'
var attachedDetail2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/attachedDetail2.jpg'
var sway = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu7.jpg'
var tsbu8 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu8.jpg'
var tsbu9 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu9.jpeg'
var tsbu10 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu10.jpg'
var tsbu11 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu11.jpeg'
var tsbu12 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu12.jpg'
var tsbu13 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu13.jpg'
var tsbu14 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu14.jpg'
var tsbu15 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu15.jpg'
var tsbu16 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu16.jpg'
var tsbu17 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu17.jpg'
var tsbu18 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu18.jpg'
var tsbu19 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu19.jpg'
var enclosure = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu20.jpg'
var puzzle = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/tsbu21.jpg'


export const allImagesDesktopOrderTsbu = [
  [/*COLUMN 1*/
      [
          {
              name: attached,
              artistName: "Lorraine Shemesh",
              title: "Attached",
              year: "2018",
              dimensions: "64 x 61 1/2 in., o/c",
              link: "tsbu4",
              privateCollection: "Private Collection"
          },
          {
              name: attachedDetail1,
              artistName: "Lorraine Shemesh",
              title: "Attached - detail",
              year: "2018",
              dimensions: "64 x 61 1/2 in., o/c",
              link: "tsbu5",
              privateCollection: "Private Collection"
          },
          {
              name: attachedDetail2,
              artistName: "Lorraine Shemesh",
              title: "Attached - detail",
              year: "2018",
              dimensions: "64 x 61 1/2 in., o/c",
              link: "tsbu6",
              privateCollection: "Private Collection"
          }
      ],
      [
          {
              name: enclosure,
              artistName: "Lorraine Shemesh",
              title: "Enclosure",
              year: "2017",
              dimensions: "60 1⁄2 x 49 1⁄2 in., o/c",
              link: "tsbu20",
              privateCollection: ""
          }
      ],
      [
          {
              name: tsbu14,
              artistName: "Lorraine Shemesh",
              title: "Inseparable",
              year: "2016",
              dimensions: "63 x 49 1⁄2 in., o/c",
              link: "tsbu14",
              privateCollection: "Private Collection"
          },
          {
              name: tsbu16,
              artistName: "Lorraine Shemesh",
              title: "Inseparable - detail",
              year: "2016",
              dimensions: "63 x 49 1⁄2 in., o/c",
              link: "tsbu16",
              privateCollection: "Private Collection"
          },
          {
              name: tsbu15,
              artistName: "Lorraine Shemesh",
              title: "Inseparable - detail",
              year: "2016",
              dimensions: "63 x 49 1⁄2 in., o/c",
              link: "tsbu19",
              privateCollection: "Private Collection"
          }
      ],
      [
          {
              name: tsbu12,
              artistName: "Lorraine Shemesh",
              title: "The Space Between Us",
              year: "2015",
              dimensions: "64 x 64 1/4 in., o/c",
              link: "tsbu12",
              privateCollection: ""
          },
          {
              name: tsbu13,
              artistName: "Lorraine Shemesh",
              title: "The Space Between Us - detail",
              year: "2015",
              dimensions: "64 x 64 1/2 in., o/c",
              link: "tsbu13",
              privateCollection: ""
          }
      ]
  ],
  [/*COLUMN 2*/
      [
          {
              name: puzzle,
              artistName: "Lorraine Shemesh",
              title: "Puzzle",
              year: "2014",
              dimensions: "65 x 65 in., o/c",
              link: "tsbu21",
              privateCollection: ""
          }
      ],
      [
          {
              name: tsbu1,
              artistName: "Lorraine Shemesh",
              title: "Accordion",
              year: "2018",
              dimensions: "65 x 55 in., o/c",
              link: "tsbu1",
              privateCollection: ""
          },
          {
              name: tsbu3,
              artistName: "Lorraine Shemesh",
              title: "Accordion – detail",
              year: "2018",
              dimensions: "65 x 55 in., o/c",
              link: "tsbu3",
              privateCollection: ""
          },
          {
              name: tsbu2,
              artistName: "Lorraine Shemesh",
              title: "Accordion – detail",
              year: "2018",
              dimensions: "65 x 55 in., o/c",
              link: "tsbu2",
              privateCollection: ""
          }
      ],
      [
          {
              name: sway,
              artistName: "Lorraine Shemesh",
              title: "Sway",
              year: "2019",
              dimensions: "72 x 57 1⁄2 in., o/c",
              link: "tsbu7",
              privateCollection: ""
          }
      ]
  ],
  [/*COLUMN 3*/
      [
          {
              name: tsbu19,
              artistName: "Lorraine Shemesh",
              title: "Interlock",
              year: "2017",
              dimensions: "52 x 45 in., o/c",
              link: "tsbu19",
              privateCollection: ""
          }
      ],
      [
          {
              name: tsbu8,
              artistName: "Lorraine Shemesh",
              title: "Hinge",
              year: "2017",
              dimensions: "63 1/2 x 47 1/2 in., o/c",
              link: "tsbu8",
              privateCollection: ""
          },
          {
              name: tsbu10,
              artistName: "Lorraine Shemesh",
              title: "Hinge – detail",
              year: "2017",
              dimensions: "63 1/2 x 47 1/2 in., o/c",
              link: "tsbu10",
              privateCollection: ""

          },
          {
              name: tsbu11,
              artistName: "Lorraine Shemesh",
              title: "Hinge – detail",
              year: "2017",
              dimensions: "63 1/2 x 47 1/2 in., o/c",
              link: "tsbu11",
              privateCollection: ""
          },
          {
              name: tsbu9,
              artistName: "Lorraine Shemesh",
              title: "Hinge - detail",
              year: "2017",
              dimensions: "63 1/2 x 47 1/2 in., o/c",
              link: "tsbu9",
              privateCollection: ""
          }
      ],
      [
          {
              name: tsbu17,
              artistName: "Lorraine Shemesh",
              title: "Riddle",
              year: "2018",
              dimensions: "60 1⁄2 x 62 in., o/c",
              link: "tsbu17",
              privateCollection: ""
          },
          {
              name: tsbu18,
              artistName: "Lorraine Shemesh",
              title: "Riddle - detail",
              year: "2018",
              dimensions: "60 1⁄2 x 62 in., o/c",
              link: "tsbu18",
              privateCollection: ""
          }
      ]
  ]          
]

export const allImagesMobileOrderTsbu = [
    [
      {
          name: attached,
          artistName: "Lorraine Shemesh",
          title: "Attached",
          year: "2018",
          dimensions: "64 x 61 1/2 in., o/c",
          link: "tsbu4",
          privateCollection: "Private Collection"
      },
      {
          name: attachedDetail1,
          artistName: "Lorraine Shemesh",
          title: "Attached - detail",
          year: "2018",
          dimensions: "64 x 61 1/2 in., o/c",
          link: "tsbu5",
          privateCollection: "Private Collection"
      },
      {
          name: attachedDetail2,
          artistName: "Lorraine Shemesh",
          title: "Attached - detail",
          year: "2018",
          dimensions: "64 x 61 1/2 in., o/c",
          link: "tsbu6",
          privateCollection: "Private Collection"
      },
      {
          name: enclosure,
          artistName: "Lorraine Shemesh",
          title: "Enclosure",
          year: "2017",
          dimensions: "60 1⁄2 x 49 1⁄2 in., o/c",
          link: "tsbu20",
          privateCollection: ""
      },
      {
          name: tsbu14,
          artistName: "Lorraine Shemesh",
          title: "Inseparable",
          year: "2016",
          dimensions: "63 x 49 1⁄2 in., o/c",
          link: "tsbu14",
          privateCollection: "Private Collection"
      },
      {
          name: tsbu16,
          artistName: "Lorraine Shemesh",
          title: "Inseparable - detail",
          year: "2016",
          dimensions: "63 x 49 1⁄2 in., o/c",
          link: "tsbu16",
          privateCollection: "Private Collection"
      },
      {
          name: tsbu15,
          artistName: "Lorraine Shemesh",
          title: "Inseparable - detail",
          year: "2016",
          dimensions: "63 x 49 1⁄2 in., o/c",
          link: "tsbu19",
          privateCollection: "Private Collection"
      },
      {
          name: tsbu12,
          artistName: "Lorraine Shemesh",
          title: "The Space Between Us",
          year: "2015",
          dimensions: "64 x 64 1/4 in., o/c",
          link: "tsbu12",
          privateCollection: ""
      },
      {
          name: tsbu13,
          artistName: "Lorraine Shemesh",
          title: "The Space Between Us - detail",
          year: "2015",
          dimensions: "64 x 64 1/2 in., o/c",
          link: "tsbu13",
          privateCollection: ""
      },
      {
          name: puzzle,
          artistName: "Lorraine Shemesh",
          title: "Puzzle",
          year: "2014",
          dimensions: "65 x 65 in., o/c",
          link: "tsbu21",
          privateCollection: ""
      },
      {
          name: tsbu1,
          artistName: "Lorraine Shemesh",
          title: "Accordion",
          year: "2018",
          dimensions: "65 x 55 in., o/c",
          link: "tsbu1",
          privateCollection: ""
      },
      {
          name: tsbu3,
          artistName: "Lorraine Shemesh",
          title: "Accordion – detail",
          year: "2018",
          dimensions: "65 x 55 in., o/c",
          link: "tsbu3",
          privateCollection: ""
      },
      {
          name: tsbu2,
          artistName: "Lorraine Shemesh",
          title: "Accordion – detail",
          year: "2018",
          dimensions: "65 x 55 in., o/c",
          link: "tsbu2",
          privateCollection: ""
      },
      {
          name: sway,
          artistName: "Lorraine Shemesh",
          title: "Sway",
          year: "2019",
          dimensions: "72 x 57 1⁄2 in., o/c",
          link: "tsbu7",
          privateCollection: ""
      },
      {
          name: tsbu19,
          artistName: "Lorraine Shemesh",
          title: "Interlock",
          year: "2017",
          dimensions: "52 x 45 in., o/c",
          link: "tsbu19",
          privateCollection: ""
      },
      {
          name: tsbu8,
          artistName: "Lorraine Shemesh",
          title: "Hinge",
          year: "2017",
          dimensions: "63 1/2 x 47 1/2 in., o/c",
          link: "tsbu8",
          privateCollection: ""
      },
      {
          name: tsbu10,
          artistName: "Lorraine Shemesh",
          title: "Hinge – detail",
          year: "2017",
          dimensions: "63 1/2 x 47 1/2 in., o/c",
          link: "tsbu10",
          privateCollection: ""

      },
      {
          name: tsbu11,
          artistName: "Lorraine Shemesh",
          title: "Hinge – detail",
          year: "2017",
          dimensions: "63 1/2 x 47 1/2 in., o/c",
          link: "tsbu11",
          privateCollection: ""
      },
      {
          name: tsbu9,
          artistName: "Lorraine Shemesh",
          title: "Hinge - detail",
          year: "2017",
          dimensions: "63 1/2 x 47 1/2 in., o/c",
          link: "tsbu9",
          privateCollection: ""
      },
      {
          name: tsbu17,
          artistName: "Lorraine Shemesh",
          title: "Riddle",
          year: "2018",
          dimensions: "60 1⁄2 x 62 in., o/c",
          link: "tsbu17",
          privateCollection: ""
      },
      {
          name: tsbu18,
          artistName: "Lorraine Shemesh",
          title: "Riddle - detail",
          year: "2018",
          dimensions: "60 1⁄2 x 62 in., o/c",
          link: "tsbu18",
          privateCollection: ""
      }
]      
]